import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/reports/shift-report`
    );
  }

  delete(packageTypeId: number) {
    return this.http.delete(
      `${environment.apiUrl}/api/packaging_types/${packageTypeId}`
    );
  }

  update(packageTypeId: number, packageType: any) {
    return this.http.patch<any>(
      `${environment.apiUrl}/api/packaging_types/${packageTypeId}`,
      packageType
    );
  }

  create(packageTypes: any[]) {
    return this.http.post<any[]>(
      `${environment.apiUrl}/api/packaging_types`,
      packageTypes
    );
  }
}
